import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SharedRouteNames } from "@globals/classes/SharedRouteNames";

function getPathName() {
  // Remove the leading and ending "/" if present before comparing to route name values.
  let pathName = window.location.pathname;
  if (pathName.startsWith("/")) pathName = pathName.substring(1);
  if (pathName.endsWith("/")) pathName = pathName.substring(0, pathName.length - 1);
  return pathName;
}

function loadComponentFunc() {
  // Load component based on current URL's path name
  const pathName = getPathName().toLowerCase();
  switch (pathName) {
    case SharedRouteNames.iFrameRoutes.driftstatus.toLowerCase():
      return import("./driftstatus/iframe-driftstatus.component");
    case SharedRouteNames.iFrameRoutes.driftstatusMap.toLowerCase():
      return import("./driftstatus-map/iframe-driftstatus-map.component");
  }
}

function loadModuleFunc() {
  const pathName = getPathName().toLowerCase();
  if (pathName === SharedRouteNames.iFrameRoutes.subscription.toLowerCase()) return import("./subscribe-unsubscribe/subscription-module-normal/iframe-subscription.module");
  if (pathName === SharedRouteNames.iFrameRoutes.stdReceivers.toLowerCase()) return import("./subscribe-unsubscribe/subscription-module-std-receivers/iframe-subscription-std-receiver.module");
}
/**
 * Determines whether the current url will need to load an Angular Module or not
 */
function isModule() {
  const pathName = getPathName().toLowerCase();
  return (
    pathName.indexOf(SharedRouteNames.iFrameRoutes.subscription.toLowerCase()) !== -1 || pathName.indexOf(SharedRouteNames.iFrameRoutes.stdReceivers.toLowerCase()) !== -1 //||
  );
}

@NgModule({
  imports: [
    // Some of the iFrame modules are just single component while others have multiple components in a module
    RouterModule.forRoot([
      { path: "", loadComponent: () => loadComponentFunc(), canMatch: [() => !isModule()] },
      { path: "", loadChildren: () => loadModuleFunc() }
    ])
  ],
  exports: [RouterModule]
})
export class IFrameModulesAppRoutingModule {}
